import getApplicantFirstName from 'utils/pivot/member/getApplicantFirstName'
import toggleClass from 'utils/DOM/toggleClass'
import forEach from 'utils/DOM/forEach'

function updateFirstNameCopy({
  hcStorage,
  prefix = '',
  suffix = '! ',
  selector = '.contactFirstName'
}) {
  const fname = getApplicantFirstName(hcStorage)
  if (fname) {
    forEach(selector, node => {
      const pf = (node.dataset && node.dataset.prefix) || prefix
      const sf = (node.dataset && node.dataset.suffix) || suffix
      node.innerHTML = `${pf}${fname}${sf}`
      toggleClass(node, 'd-none', false)
    })
  }
}

export default updateFirstNameCopy
